/**
 * Acesso à notificação curta dos miolos.
 *
 * Papel: o contexto que o `ProvedorDeNotificacao` preenche e o `useNotificacao`
 * que os componentes de dentro de um `QuadroEmbutido` usam para avisar
 * "✓ Registro salvo" e afins.
 *
 * Como usar: chamar `useNotificacao()` no componente e `notificar(texto)` depois
 * do que deu certo, ou `notificar(texto, false)` para falha. A mensagem nunca
 * leva nome, CPF nem valor (regra 2 do `CLAUDE.md`): onde a origem escrevia
 * "<nome> já está na Folha", a mensagem é genérica.
 */
import { createContext, useContext } from 'react';

/** Mostra uma mensagem por 3 s; `ok` falso usa o fundo de falha. */
export type Notificar = (mensagem: string, ok?: boolean) => void;

/** Preenchido pelo `ProvedorDeNotificacao`; `null` fora dele. */
export const ContextoDeNotificacao = createContext<Notificar | null>(null);

/**
 * Devolve a função que mostra a notificação curta.
 *
 * Quem chama precisa estar dentro de um `ProvedorDeNotificacao`, que o
 * `QuadroEmbutido` já monta. Fora dele, lança: uma notificação que não aparece
 * em lugar nenhum esconderia que a gravação deu certo.
 *
 * @returns A função `notificar`.
 */
export function useNotificacao(): Notificar {
  const notificar = useContext(ContextoDeNotificacao);
  if (notificar === null) {
    throw new Error('useNotificacao precisa estar dentro de um ProvedorDeNotificacao.');
  }
  return notificar;
}
